// initialize bugsnag ASAP, before other imports
import bugsnag from "bugsnag-js";
import React from "react";
import { UncontrolledAlert } from "reactstrap";
import createPlugin from "bugsnag-react";
import StartupForm from "./startup_form";

// const bugsnagClient = bugsnag({
//   apiKey: process.env.BUGSNAG_API_KEY,
//   releaseStage: process.env.NODE_ENV
// });
// const ErrorBoundary = bugsnagClient.use(createPlugin(React));
const FallbackComponent = () => (
  <div className='row d-flex justify-content-center mb-3'>
    <UncontrolledAlert color='warning'>
      申し訳ありません、予期しないエラーが発生しました、お手数ですが、再度ページを読み込んで下さい。
    </UncontrolledAlert>
  </div>
);

function App(props) {
  return (
    // <ErrorBoundary FallbackComponent={FallbackComponent}>
      <StartupForm {...props} />
    // </ErrorBoundary>
  );
}

export default App;
